import React, { useEffect, useRef, useState } from "react";
import {
  motion,
  useScroll,
  useTransform,
  useMotionValueEvent,
  animate,
} from "framer-motion";

import {
  ChevronDoubleDownIcon,
  ChevronDoubleUpIcon,
} from "@heroicons/react/24/solid";

import Header from "./components/header";
import Footer from "./components/footer";

import scrollConfig from "./config.json";

import Scene from "./components/Scene";

export default function Home() {
  const containerRef = useRef();
  const titleRef = useRef();

  const contentRef = useRef();
  const sceneRef = useRef();

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end end"],
  });

  // Get Scroll Percentage
  const [currentText, setCurrentText] = useState("Feel. Journal. Connect");
  const [subtitle, setSubtitle] = useState(
    "Emotionly turns your thoughts into bridges — not walls."
  );

  const [showScrollDown, setShowScrollDown] = useState(true);
  const [showScrollUp, setShowScrollUp] = useState(false);

  const [test, setTest] = useState("Test Text");
  const [scrollPercentage, setScrollPercentage] = useState(0);

  const [isloading, setIsLoading] = useState(true);

  const [spline, setSpline] = useState(null);
  const [currentMesh, setCurrentMesh] = useState("main_image_1");

  useMotionValueEvent(
    scrollYProgress,
    "change",
    (progress) => {
      if (!spline) {
        console.log("Spline not loaded yet");
        return;
      }

      scrollConfig.forEach((section) => {
        const start = section.start;
        const end = section.end;
        const text = section.text;
        const subtitle = section.subtitle;
        const mesh = section.mesh;

        let formattedProgress = parseFloat(progress.toFixed(5));

        //setScrollPercentage(formattedProgress);

        if (formattedProgress >= start && formattedProgress <= end) {
          let mainMesh = spline.findObjectByName(mesh);

          scrollConfig.forEach((con) => {
            let meshObject = spline.findObjectByName(con.mesh);
            if (meshObject) {
              meshObject.visible = false;
            }
          });

          if (mainMesh) {
            mainMesh.visible = true;
          }

          setCurrentText(text);
          setSubtitle(subtitle);
          setCurrentMesh(mesh);
        }
      });

      let maxScroll = 0.95;

      if (progress > 0.88) {
        // make contentRef in the middle of the screen

        if (progress > 0.9) {
          sceneRef.current.style.display = "none";
          contentRef.current.style.height = "100vh";
          // setCurrentText("We are commited");
          // setSubtitle(
          //   "Building a community driven by emotions with deeper relationships amongst humanity"
          // );
        }

        // contentRef.current.style.transform = "translateY(-50%)";
        // contentRef.current.style.top = "50%";
        // contentRef.current.style.position = "absolute";
        // contentRef.current.style.left = "50%";
        // contentRef.current.style.transform = "translate(-50%, -50%)";
      } else {
        // make contentRef in the top of the screen

        if (progress < 0.9) {
          sceneRef.current.style.display = "block";
          contentRef.current.style.height = "auto";
        }

        // contentRef.current.style.transform = "translateY(0)";
        // contentRef.current.style.position = "relative";
        // contentRef.current.style.top = "0";
        // contentRef.current.style.left = "0";
        // contentRef.current.style.transform = "translate(0, 0)";
      }

      setShowScrollDown(progress < 0.875);
      setShowScrollUp(progress > 0.125); // more forgiving threshold
    },
    [spline]
  );

  useEffect(() => {
    // Always set the scroll position to 0 on load
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [containerRef]);

  function onLoad(spline) {
    setSpline(spline);

    let mainImage1 = spline.findObjectByName("main_image_1");

    setIsLoading(false);

    scrollConfig.forEach((con) => {
      let meshObject = spline.findObjectByName(con.mesh);

      if (meshObject) {
        meshObject.visible = false;
      }
    });

    if (mainImage1) {
      mainImage1.visible = true;
    }
  }

  return (
    <div className="min-h-screen bg-black overflow-x-hidden py-6 sm:p-5 w-screen">
      <Header />

      <div
        ref={containerRef}
        className="relative w-[100vw] pt-10 overflow-x-hidden sm:pt-0 h-[800vh]"
      >
        <div className="h-[90vh] sm:h-[90vh] overflow-x-hidden flex flex-col sm:flex-row align-middle fixed justify-between w-full">
          <div
            ref={contentRef}
            className="w-full z-1000 p-2 text-center flex flex-col justify-center bg-transparent "
          >
            <motion.div
              ref={titleRef}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              key={currentText}
              className="text-[5vw] sm:text-[3vw] font-semibold text-white"
            >
              {currentText}
            </motion.div>

            <motion.div className="text-[2.5vw] sm:text-[1.2vw] text-gray-200">
              {subtitle}
            </motion.div>

            <div className="w-full">
              <button
                onClick={() => {
                  console.log("Discord clicked");
                  window.open("https://discord.gg/mm9MG7uEkC", "_blank");
                }}
                className="text-[2.5vw] sm:text-[1.2vw] text-gray-200 bg-transparent border-2 border-gray-200 sm:w-48 rounded-full px-4 py-2 mt-4 hover:bg-gray-200 hover:text-black transition duration-300 items-center justify-center align-middle ease-in-out"
              >
                Join Beta Testing
              </button>
            </div>
          </div>
          <div ref={sceneRef} className="w-full h-full">
            <Scene isLoading={isloading} onLoad={onLoad} />
          </div>
        </div>

        <div className="fixed bottom-12 right-6 z-[1000000] flex flex-col gap-2">
          {showScrollUp && (
            <button
              onClick={() => {
                const currentIndex = scrollConfig.findIndex(
                  (section) => section.mesh === currentMesh
                );

                const prevIndex = currentIndex - 1;
                const prevStart =
                  scrollConfig[prevIndex].start *
                  containerRef.current.scrollHeight *
                  0.94;

                window.scrollTo({
                  top: prevStart,
                  behavior: "smooth",
                });
              }}
              className="bg-white/10 hover:bg-white/20 p-3 rounded-full transition"
            >
              <ChevronDoubleUpIcon className="w-6 h-6 text-white" />
            </button>
          )}

          {showScrollDown && (
            <button
              onClick={() => {
                const currentIndex = scrollConfig.findIndex(
                  (section) => section.mesh === currentMesh
                );

                // console.log("Current Index", currentIndex);

                // console.log(
                //   "containerRef.current.scrollHeight",
                //   containerRef.current.scrollHeight
                // );

                const nextIndex = currentIndex + 1;
                // console.log("Next Index", nextIndex);

                // console.log(
                //   "scrollConfig[nextIndex].start",
                //   scrollConfig[nextIndex].start
                // );

                const nextStart =
                  scrollConfig[nextIndex].start *
                  containerRef.current.scrollHeight *
                  0.94;

                console.log("Next Start", nextStart);

                setTest(
                  `Next Start: ${nextStart},
                  Total Height: ${containerRef.current.scrollHeight},
                  ${scrollConfig[nextIndex].start}
                  Current Index: ${currentIndex}, Next Index: ${nextIndex}`
                );

                window.scrollTo({
                  top: nextStart,
                  behavior: "smooth",
                });
              }}
              className="bg-white/10 hover:bg-white/20 p-3 rounded-full transition"
            >
              <ChevronDoubleDownIcon className="w-6 h-6 text-white" />
            </button>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}
